import {
  doRefreshToken,
  doSentLinkVerificationEmail,
} from 'actions/authAction';
import {
  doVerifyOtp,
  doSentCitCall,
  doSentSMS,
  doSubmitPhone,
} from 'actions/saleActions';
import SellerVerification from 'components/PageSellerRegistration/SellerVerification';
import AuthInterface from 'interface/reducers/auth';
import React from 'react';
import { connect } from 'react-redux';

interface IModalSellerVerificationProps {
  dataAuth: AuthInterface;
  isOpenSellerVerification: boolean;
  isOpenExistingModal: boolean;
  phone: string;
  setIsOpenExistingModal: (param) => void;
  setPhone: (param) => void;
  toggleSellerVerification: () => void;
  toggleExistingModal: () => void;
  refreshToken: () => Promise<unknown>;
  sentCitCall: (payload) => Promise<unknown>;
  sentSMS: (payload) => Promise<unknown>;
  verifyOtp: (payload) => Promise<unknown>;
  submitPhone: (payload) => Promise<unknown>;
}

const ModalSellerVerification: React.FC<IModalSellerVerificationProps> = (
  props,
) => {
  const {
    dataAuth,
    isOpenExistingModal,
    isOpenSellerVerification,
    phone,
    toggleExistingModal,
    toggleSellerVerification,
    setPhone,
    setIsOpenExistingModal,
    refreshToken,
    sentCitCall,
    sentSMS,
    verifyOtp,
    submitPhone,
  } = props;

  return (
    <SellerVerification
      isExistingSeller={
        !dataAuth.userdata.seller_verification &&
        dataAuth.userdata.roles.includes('seller')
      }
      isOpen={isOpenSellerVerification}
      toggle={toggleSellerVerification}
      doRefreshToken={refreshToken}
      doVerifyOtp={verifyOtp}
      doSentCitCall={sentCitCall}
      doSentSMS={sentSMS}
      doSubmitPhone={submitPhone}
      phoneNumber={phone}
      setPhone={setPhone}
      toggleExistingModal={toggleExistingModal}
      isOpenExistingModal={isOpenExistingModal}
      setIsOpenExistingModal={setIsOpenExistingModal}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    dataAuth: state.dataAuth,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    refreshToken: () => dispatch(doRefreshToken()),
    sentCitCall: (payload) => dispatch(doSentCitCall(payload)),
    sentSMS: (payload) => dispatch(doSentSMS(payload)),
    verifyOtp: (payload) => dispatch(doVerifyOtp(payload)),
    submitPhone: (payload) => dispatch(doSubmitPhone(payload)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalSellerVerification);
